export const EXTERNAL_NOTIFICATION_EVENTS_MAP = {
  MASTER_CREATE_TASK: "m_create_task",
  CLIENT_CREATE_TASK: "c_create_task",
  MASTER_ACCEPT_TASK: "m_accept_task",
  MASTER_CANCEL_TASK: "m_cancel_task",
  MASTER_CHANGE_TASK: "m_change_task",
  NOTIFY_MASTER: "notify_m",
  NOTIFY_MASTER_PERSONAL: "notify_m_personal",
  NOTIFY_CLIENT: "notify_c",
  CLIENT_CANCEL_TASK: "c_cancel_task",
  CLIENT_CHANGE_TASK: "c_change_task",
};

const EVENTS = EXTERNAL_NOTIFICATION_EVENTS_MAP;
export const AVAILABLE_TASK_AUTO_EXTERNAL_NOTIFICATIONS = [
  EVENTS.NOTIFY_MASTER,
  EVENTS.NOTIFY_CLIENT,
  EVENTS.MASTER_CHANGE_TASK,
  EVENTS.CLIENT_CHANGE_TASK,
  EVENTS.MASTER_CREATE_TASK,
  EVENTS.MASTER_ACCEPT_TASK,
  EVENTS.CLIENT_CANCEL_TASK,
  EVENTS.MASTER_CANCEL_TASK,
  // EVENTS.NOTIFY_MASTER_PERSONAL,
];
export const DISABLED_TASK_MANUAL_EXTERNAL_NOTIFICATIONS = [
  EVENTS.CLIENT_CANCEL_TASK,
  EVENTS.CLIENT_CHANGE_TASK,
  EVENTS.CLIENT_CREATE_TASK,
  EVENTS.NOTIFY_MASTER,
  EVENTS.NOTIFY_MASTER_PERSONAL,
];
export const EXTERNAL_NOTIFICATION_EVENTS_ARRAY = Object.values(EVENTS);
